import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { DESIGNATION, ID } from 'store/medicalHistory';

import { Button } from './styles';

export default function DrugButton({ data, onSelect, isActive, disabled }) {
  const onClick = useCallback(() => onSelect(data), [data, onSelect]);

  return (
    <Button key={data[ID]} value={data} onClick={onClick} isActive={isActive} disabled={disabled || isActive}>
      {data[DESIGNATION] || '-'}
    </Button>
  );
}

DrugButton.defaultProps = { isActive: false, disabled: false };
DrugButton.propTypes = {
  data: PropTypes.shape({ [ID]: PropTypes.string.isRequired, [DESIGNATION]: PropTypes.string }).isRequired,
  onSelect: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
};
